"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onModeration = exports.getShops = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _utils = require("@package/utils");

var _request = _interopRequireDefault(require("@package/request"));

var _logger = require("@package/logger");

var _errors = require("@package/errors");

var notifications = _interopRequireWildcard(require("@package/notifications"));

var _slice = require("./slice");

var getShops = function getShops() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(dispatch) {
      var result;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              (0, _logger.push)({
                message: 'Получение данных магазинов'
              });
              dispatch((0, _slice.getShopsRequestAction)());
              _context.next = 5;
              return (0, _request["default"])({
                url: '/shops',
                method: 'get',
                params: query
              });

            case 5:
              result = _context.sent;
              dispatch((0, _slice.getShopsRequestSuccessAction)(result['data']));
              _context.next = 18;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);

              if (!(_context.t0 instanceof _errors.UnauthorizedError)) {
                _context.next = 13;
                break;
              }

              return _context.abrupt("return", void 0);

            case 13:
              (0, _logger.push)({
                message: 'Ошибка при получении данных магазинов'
              });

              if (!(!_context.t0['data'] && !_context.t0['data']['code'])) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return", void 0);

            case 16:
              dispatch((0, _slice.getShopsRequestFailAction)(_context.t0['data']));
              dispatch(notifications.pushFail(_context.t0['data']));

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.getShops = getShops;

var onModeration = function onModeration(shopId) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(dispatch) {
      var count, shop, notExit, _yield$request, data;

      return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              (0, _logger.push)({
                message: 'Отправить магазин на модерацию'
              });
              dispatch((0, _slice.changeShopStatusRequestAction)(shopId));
              _context2.next = 5;
              return (0, _request["default"])({
                url: '/shops/' + shopId + '/status',
                method: 'put',
                data: {
                  code: 2,
                  reasonMessage: 'На модерацию'
                }
              });

            case 5:
              count = 0;
              shop = null;
              notExit = true;

            case 8:
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Опрос на созданный магазин с id: ' + shopId
              });
              ++count;
              _context2.next = 12;
              return (0, _utils.sleep)(window.env['ATTEMPT_WAIT']);

            case 12:
              _context2.next = 14;
              return (0, _request["default"])({
                url: "/shops/" + shopId,
                method: 'get'
              });

            case 14:
              _yield$request = _context2.sent;
              data = _yield$request.data;

              if (data['id'] === shopId && data['status'] !== 'New') {
                shop = data;
                notExit = false;
              }

              if (!(count >= Number(window.env['ATTEMPT_COUNT']))) {
                _context2.next = 19;
                break;
              }

              throw {
                data: {
                  code: '1.1.1'
                }
              };

            case 19:
              if (notExit) {
                _context2.next = 8;
                break;
              }

            case 20:
              dispatch((0, _slice.changeShopStatusRequestSuccessAction)(shop));
              dispatch(notifications.pushSuccess('Магазин отправлен на модерацию'));
              _context2.next = 34;
              break;

            case 24:
              _context2.prev = 24;
              _context2.t0 = _context2["catch"](0);
              console.log(_context2.t0['data']);

              if (!(_context2.t0 instanceof _errors.UnauthorizedError)) {
                _context2.next = 29;
                break;
              }

              return _context2.abrupt("return", void 0);

            case 29:
              (0, _logger.push)({
                message: 'Ошибка при изменении статуса магазина'
              });

              if (!(!_context2.t0['data'] && !_context2.t0['data']['code'])) {
                _context2.next = 32;
                break;
              }

              return _context2.abrupt("return", void 0);

            case 32:
              dispatch((0, _slice.changeShopStatusRequestFailAction)(shopId, _context2.t0['data']));
              dispatch(notifications.pushFail(_context2.t0['data']));

            case 34:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 24]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.onModeration = onModeration;